import $ from 'jquery';
window.$ = window.jQuery = $;

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import 'select2/dist/js/select2.full.min.js';
import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
window.AirDatepicker = AirDatepicker;
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// Если нужен Bootstrap JS:
import './bootstrap';

// Импортируй CSS, если используешь webpack для стилей:
import 'select2/dist/css/select2.min.css';
import 'swiper/css/bundle';
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css';